const papersDataAqaGcse = {
  mathematics: [
    {
      year: '2023',
      papers: [
        {
          label: '1F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83001F-QP-JUN23.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83001F-MS-JUN23.PDF',
        },
        {
          label: '1H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83001H-QP-JUN23.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83001H-MS-JUN23.PDF',
        },
        {
          label: '2F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83002F-QP-JUN23.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83002F-MS-JUN23.PDF',
        },
        {
          label: '2H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83002H-QP-JUN23.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83002H-MS-JUN23.PDF',
        },
        {
          label: '3F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83003F-QP-JUN23.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83003F-MS-JUN23.PDF',
        },
        {
          label: '3H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83003H-QP-JUN23.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-83003H-MS-JUN23.PDF',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: '1F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-83001F-QP-NOV22.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-83001F-MS-NOV22.PDF',
        },
        {
          label: '1H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-83001H-QP-NOV22.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-83001H-MS-NOV22.PDF',
        },
        {
          label: '2F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-83002F-QP-NOV22.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-83002F-MS-NOV22.PDF',
        },
        {
          label: '2H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-83002H-QP-NOV22.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-83002H-MS-NOV22.PDF',
        },
        {
          label: '3F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-83003F-QP-NOV22.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-83003F-MS-NOV22.PDF',
        },
        {
          label: '3H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-83003H-QP-NOV22.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/november/AQA-83003H-MS-NOV22.PDF',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: '1F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83001F-QP-NOV21.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83001F-MS-NOV21.PDF',
        },
        {
          label: '1H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83001H-QP-NOV21.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83001H-MS-NOV21.PDF',
        },
        {
          label: '2F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83002F-QP-NOV21.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83002F-MS-NOV21.PDF',
        },
        {
          label: '2H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83002H-QP-NOV21.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83002H-MS-NOV21.PDF',
        },
        {
          label: '3F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83003F-QP-NOV21.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83003F-MS-NOV21.PDF',
        },
        {
          label: '3H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83003H-QP-NOV21.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-83003H-MS-NOV21.PDF',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: '1F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83001F-QP-NOV20.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83001F-W-MS-NOV20.PDF',
        },
        {
          label: '1H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83001H-QP-NOV20.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83001H-W-MS-NOV20.PDF',
        },
        {
          label: '2F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83002F-QP-NOV20.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83002F-W-MS-NOV20.PDF',
        },
        {
          label: '2H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83002H-QP-NOV20.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83002H-W-MS-NOV20.PDF',
        },
        {
          label: '3F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83003F-QP-NOV20.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83003F-W-MS-NOV20.PDF',
        },
        {
          label: '3H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83003H-QP-NOV20.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-83003H-W-MS-NOV20.PDF',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: '1F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-83001F-QP-JUN19.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-83001F-W-MS-JUN19.PDF',
        },
        {
          label: '1H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-83001H-QP-JUN19.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-83001H-W-MS-JUN19.PDF',
        },
        {
          label: '2F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-83002F-QP-JUN19.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-83002F-W-MS-JUN19.PDF',
        },
        {
          label: '2H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-83002H-QP-JUN19.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-83002H-W-MS-JUN19.PDF',
        },
        {
          label: '3F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-83003F-QP-JUN19.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-83003F-W-MS-JUN19.PDF',
        },
        {
          label: '3H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-83003H-QP-JUN19.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-83003H-W-MS-JUN19.PDF',
        },
      ],
    },
  ],
  biology: [
    {
      year: '2023',
      papers: [
        {
          label: '1F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84611F-QP-JUN23.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84611F-MS-JUN23.PDF',
        },
        {
          label: '1H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84611H-QP-JUN23.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84611H-MS-JUN23.PDF',
        },
        {
          label: '2F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84612F-QP-JUN23.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84612F-MS-JUN23.PDF',
        },
        {
          label: '2H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84612H-QP-JUN23.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84612H-MS-JUN23.PDF',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: '1F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84611F-QP-JUN22.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84611F-MS-JUN22.PDF',
        },
        {
          label: '1H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84611H-QP-JUN22.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84611H-MS-JUN22.PDF',
        },
        {
          label: '2F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84612F-QP-JUN22.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84612F-MS-JUN22.PDF',
        },
        {
          label: '2H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84612H-QP-JUN22.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84612H-MS-JUN22.PDF',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: '1F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84611F-QP-NOV21.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84611F-MS-NOV21.PDF',
        },
        {
          label: '1H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84611H-QP-NOV21.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84611H-MS-NOV21.PDF',
        },
        {
          label: '2F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84612F-QP-NOV21.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84612F-MS-NOV21.PDF',
        },
        {
          label: '2H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84612H-QP-NOV21.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84612H-MS-NOV21.PDF',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: '1F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84611F-QP-NOV20.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84611F-W-MS-NOV20.PDF',
        },
        {
          label: '1H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84611H-QP-NOV20.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84611H-W-MS-NOV20.PDF',
        },
        {
          label: '2F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84612F-QP-NOV20.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84612F-W-MS-NOV20.PDF',
        },
        {
          label: '2H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84612H-QP-NOV20.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84612H-W-MS-NOV20.PDF',
        },
      ],
    },
  ],
  chemistry: [
    {
      year: '2023',
      papers: [
        {
          label: '1F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84621F-QP-JUN23.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84621F-MS-JUN23.PDF',
        },
        {
          label: '1H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84621H-QP-JUN23.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84621H-MS-JUN23.PDF',
        },
        {
          label: '2F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84622F-QP-JUN23.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84622F-MS-JUN23.PDF',
        },
        {
          label: '2H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84622H-QP-JUN23.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84622H-MS-JUN23.PDF',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: '1F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84621F-QP-JUN22.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84621F-MS-JUN22.PDF',
        },
        {
          label: '1H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84621H-QP-JUN22.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84621H-MS-JUN22.PDF',
        },
        {
          label: '2F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84622F-QP-JUN22.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84622F-MS-JUN22.PDF',
        },
        {
          label: '2H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84622H-QP-JUN22.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84622H-MS-JUN22.PDF',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: '1F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84621F-QP-NOV21.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84621F-MS-NOV21.PDF',
        },
        {
          label: '1H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84621H-QP-NOV21.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84621H-MS-NOV21.PDF',
        },
        {
          label: '2F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84622F-QP-NOV21.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84622F-MS-NOV21.PDF',
        },
        {
          label: '2H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84622H-QP-NOV21.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84622H-MS-NOV21.PDF',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: '1F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84621F-QP-NOV20.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84621F-W-MS-NOV20.PDF',
        },
        {
          label: '1H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84621H-QP-NOV20.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84621H-W-MS-NOV20.PDF',
        },
        {
          label: '2F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84622F-QP-NOV20.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84622F-W-MS-NOV20.PDF',
        },
        {
          label: '2H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84622H-QP-NOV20.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84622H-W-MS-NOV20.PDF',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: '1F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-84621F-QP-JUN19.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-84621F-W-MS-JUN19.PDF',
        },
        {
          label: '1H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-84621H-QP-JUN19.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-84621H-W-MS-JUN19.PDF',
        },
      ],
    },
  ],
  physics: [
    {
      year: '2023',
      papers: [
        {
          label: '2F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84632F-QP-JUN23.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84632F-MS-JUN23.PDF',
        },
        {
          label: '2H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84632H-QP-JUN23.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2023/june/AQA-84632H-MS-JUN23.PDF',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: '1F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84631F-QP-JUN22.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84631F-MS-JUN22.PDF',
        },
        {
          label: '1H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84631H-QP-JUN22.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84631H-MS-JUN22.PDF',
        },
        {
          label: '2F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84632F-QP-JUN22.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84632F-MS-JUN22.PDF',
        },
        {
          label: '2H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84632H-QP-JUN22.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2022/june/AQA-84632H-MS-JUN22.PDF',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: '1F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84631F-QP-NOV21.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84631F-MS-NOV21.PDF',
        },
        {
          label: '1H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84631H-QP-NOV21.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84631H-MS-NOV21.PDF',
        },
        {
          label: '2F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84632F-QP-NOV21.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84632F-MS-NOV21.PDF',
        },
        {
          label: '2H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84632H-QP-NOV21.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2021/november/AQA-84632H-MS-NOV21.PDF',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: '1F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84631F-QP-NOV20.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84631F-W-MS-NOV20.PDF',
        },
        {
          label: '1H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84631H-QP-NOV20.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84631H-W-MS-NOV20.PDF',
        },
        {
          label: '2F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84632F-QP-NOV20.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84632F-W-MS-NOV20.PDF',
        },
        {
          label: '2H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84632H-QP-NOV20.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2020/november/AQA-84632H-W-MS-NOV20.PDF',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: '1F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-84631F-QP-JUN19.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-84631F-W-MS-JUN19.PDF',
        },
        {
          label: '2F',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-84632F-QP-JUN19.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-84632F-W-MS-JUN19.PDF',
        },
        {
          label: '2H',
          link:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-84632H-QP-JUN19.PDF',
          marking:
            'https://filestore.aqa.org.uk/sample-papers-and-mark-schemes/2019/june/AQA-84632H-W-MS-JUN19.PDF',
        },
      ],
    },
  ],
};

export default papersDataAqaGcse;
